<template>
  <div>
    <LoadingPage v-if="isLoadPage" />
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card no-body header-classes="bg-transparent">
            <b-card-header>
              <div class="d-flex justify-content-between">
                <h2 slot="header" class="mb-0">รายละเอียดงาน</h2>
                <div>
                  <b-dropdown
                    size="sm"
                    right
                    :text="item.title"
                    class="mx-2"
                    v-for="item in file"
                    :key="item.type"
                    :variant="PDFFileExist[item.type] ? 'success' : ''">
                    <b-dropdown-item
                      link-class="d-flex align-items-center"
                      @click="getDownloadJobPDF(item.type)">
                      <b-icon icon="file-text" font-scale="1"></b-icon
                      >ดาวน์โหลด{{ item.title }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      link-class="d-flex align-items-center"
                      v-if="!PDFFileExist[item.type]"
                      @click="handleModalUploadFile(item)">
                      <b-icon icon="upload" font-scale="1"></b-icon>อัพโหลด{{
                        item.title
                      }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </b-card-header>
            <b-tabs content-class="mt-3" fill class="tab-manage-driver">
              <TabJobDetails
                :form="form"
                v-model="selected"
                :customerList="customer_list"
                @createDriverJob="createDriverJob" />
              <TabReportFromDriver :form="form" />
            </b-tabs>
          </card>
          <ModalUploadFile
            :modal="modal"
            :form="form"
            ref="uploadFile"
            @confirmModal="confirmUploadFile" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import jobServices from "@/api/job.service.js";
import TabJobDetails from "@/components/Job/Tab/JobDetails.vue";
import TabReportFromDriver from "@/components/Job/Tab/ReportFromDriver.vue";
import ModalUploadFile from "@/components/Job/ModalUploadFile.vue";
import CalPrice from "./components/CalPrice.vue";
import downloadImage from "@/util/downloadImage.js";
import {
  TYPE_INVOICE,
  TYPE_QUOTATION,
  TYPE_RECEIPT,
} from "@/util/constants.js";

export default {
  components: { TabJobDetails, TabReportFromDriver, CalPrice, ModalUploadFile },
  props: {},
  data() {
    return {
      downloadImage,
      isLoadPage: false,
      file: [
        { type: TYPE_QUOTATION, title: "ใบเสนอราคา" },
        { type: TYPE_INVOICE, title: "ใบแจ้งหนี้" },
        { type: TYPE_RECEIPT, title: "ใบเสร็จ" },
      ],
      modal: {
        show: false,
        isLoad: false,
        item: {
          type: null,
          title: "",
        },
      },
      PDFFileExist: {
        invoice: false,
        quotation: false,
        receipt: false,
      },
      empoyeeList: [],
      vehicle_type: [],
      perliters_prices: [],
      customer_list: [],
      customer_rates: [],
      customer_rate_seleted: [],
      selected: null,
      form: {
        quotation: null,
        invoice: null,
        receipt: null,
        driver: {
          fullName: null,
        },
        driverTimeStart: null,
        job_id: null,
        action: "isEdit",
        job_name: "",
        customer: "",
        rate_type: "custom",
        rate: "",
        routes: "",
        distance: "",
        price_perliter: "",
        sale_price: "",
        vehicle_type: null,
        fee: "",
        price_service_fee: "",
        price_after_service_fee: "",
        discount: "",
        price_discount: "",
        price_after_discount: "",
        rate_before_vat: 0,
        checkVat: "",
        vatPercent: 7,
        vat: 0,
        price_vat: "",
        check_withholding_tax: "",
        withholdingTaxPercent: 3,
        withholdingTax: 0,
        net: 0,
        fuel_price_id: null,
        additional_work: [{ detail: "", rate: "" }],
        categoryName: "",
        statusJob: null,
      },
    };
  },
  methods: {
    handleModalUploadFile(item) {
      this.modal.show = true;
      this.modal.item = item;
    },
    async confirmUploadFile(type) {
      this.modal.isLoad = true;
      await this.uploadFile(type);

      this.$refs.uploadFile.closeModalConfirm();
    },
    async uploadFile(type) {
      const formData = new FormData();
      formData.append("file", this.form[type]);
      formData.append("job_id", this.form.job_id);

      try {
        if (type === TYPE_INVOICE) {
          await jobServices.uploadFileInvoiceJob(formData);
        } else if (type === TYPE_QUOTATION) {
          await jobServices.uploadFileQuotationJob(formData);
        } else if (type === TYPE_RECEIPT) {
          await jobServices.uploadFileReceiptJob(formData);
        }

        alert("อัพโหลดไฟล์เสร็จสิ้น");
        await this.getJobPDF();
      } catch (err) {
        console.log(err);
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async getDownloadJobPDF(typePDF) {
      if (this.PDFFileExist[typePDF]) {
        const { data } = await jobServices.getFileSignByType({
          job_id: this.form.job_id,
          type_name: typePDF,
        });

        const pdfBlob = data.data;
        this.downloadImage(pdfBlob);
      } else {
        const { data } = await jobServices.getFileUnSignByType({
          job_id: this.form.job_id,
          type_name: typePDF,
        });
        const pdfBlob = data.data;
        this.downloadImage(pdfBlob);
      }
    },
    async getJob() {
      try {
        this.isLoadPage = true;
        const response = await jobServices.getJobFull(this.$route.params);
        if (response.status != 200) {
          this.$router.push({
            name: "manageJob",
          });
        }
        const data = response.data.data;

        const jobRoutes = data.jobRoutes.map((item) => {
          return {
            ...item,
            visible: true,
          };
        });

        const driver = data.driver;
        driver.fullName = `${driver.firstname} ${driver.lastname}`;

        //TODO  ยังไม่ได้ทำ คำนวน vat
        this.form = {
          customer: data.customer,
          job_id: data.id,
          job_name: data.job_name,
          routes: jobRoutes,
          additional_work: data.jobAdditional.map((item) => {
            return {
              detail: item.name,
              rate: item.price,
            };
          }),
          price_perliter: +data.oil_price,
          discount: +data.discount_percent,
          price_discount: +data.discount,
          rate_before_vat: +data.price_before_service_charge,
          price_after_discount: +data.price_after_discount,
          price_service_fee: +data.service_charge,
          price_after_service_fee: +data.price_after_service_charge,
          vatPercent: +data.vat_percent,
          vat: +data.vat,
          price_vat: +data.price_vat,
          withholdingTax: +data.withholding_tax,
          withholdingTaxPercent: +data.withholding_tax_percent,
          net: +data.net,
          distance: +data.distance,
          distance_to_warehouse: +data.distance_to_warehouse,
          sale_price: +data.sale_price,
          driverDateStart: data.started_datetime.substring(0, 16),
          driverDateEnd: data.ended_datetime.substring(0, 16),
          rate_type: data.jobRateType.id,
          categoryName: data.customer_route_detail_name,
          driver: driver,
          driverTimeStart: data.driver_assigned_date.substring(0, 16),
          statusJob: data.status,
          // fee: +data.price_before_service_charge,
          // customer: data.customer_name,
          // rate_type: data.job.rate_type,
          // driver: data.job.driver,
          // rate: "",
          // rate_before_vat: +data.job.rate_before_vat,
          // distance: data.job.distance,
          // price_perliter: data.job.price_perliter,
          // sale_price: data.job.sale_price,
          // vehicle_type: data.job.vehicle_type,
          // fee: +data.job.fee,
          // price_service_fee: +data.job.price_service_fee,
          // price_after_service_fee: +data.job.price_after_service_fee,
          // discount: +data.job.discount,
          // price_discount: +data.job.price_discount,
          // price_after_discount: +data.job.price_after_discount,
          // checkVat: "",
          // vatPercent: +data.job.vat_percent,
          // vat: +data.job.vat,
          // price_vat: +data.job.price_vat,
          // check_withholding_tax: "",
          // withholdingTaxPercent: +data.job.withholdingTaxPercent,
          // withholdingTax: +data.job.withholding_tax,
          // net: +data.job.net,
          // fuel_price_id: null,
          // additional_work: data.jobAdditional,
        };
        this.selected = data.driver;
      } catch (error) {
        console.log("error JobDetail[getJob]", error);
      } finally {
        this.isLoadPage = false;
      }
    },
    async getJobPDF() {
      const { data } = await jobServices.getJobPDFDetails({
        job_id: this.$route.params.id,
      });
      if (data.data) {
        this.PDFFileExist = data.data;
      }
    },
    async createDriverJob() {
      const payload = {
        job_id: this.form.job_id,
        driver_id: this.selected.id,
      };

      try {
        await jobServices.createJobDriver(payload);
        alert("เพิ่มพนักงานขับรถเสร็จสิ้น");
        await this.getJob();
      } catch (err) {
        console.log(err);
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    handleSelect(c) {
      console.log(c, "c");
    },
  },
  async mounted() {
    await this.getJob();
    await this.getJobPDF();
  },
};
</script>

<style scoped></style>
<style lang="scss" scoped></style>
